const requestCameraPermissions = async () => true;

const requestMediaLibraryPermissions = async () => true;

export { requestCameraPermissions, requestMediaLibraryPermissions };
